import React from 'react';

const QuoteExport = ({ favorites, darkMode }) => {
  const exportToJSON = () => {
    const dataStr = JSON.stringify(favorites, null, 2);
    const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
    
    const exportFileDefaultName = `favorite-quotes-${new Date().toISOString().split('T')[0]}.json`;
    
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
  };

  const exportToText = () => {
    const textContent = favorites.map(quote => 
      `"${quote.text}"\n- ${quote.category} (${quote.date})\n\n`
    ).join('');
    
    const dataStr = textContent;
    const dataUri = 'data:text/plain;charset=utf-8,'+ encodeURIComponent(dataStr);
    
    const exportFileDefaultName = `favorite-quotes-${new Date().toISOString().split('T')[0]}.txt`;
    
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
  };

  const shareAllFavorites = async () => {
    const shareText = favorites.map(quote => `"${quote.text}"`).join('\n\n');
    
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Moje obľúbené citáty',
          text: shareText,
        });
      } catch (err) {
        console.log('Zdieľanie nie je podporované');
        navigator.clipboard.writeText(shareText);
        alert('Všetky citáty boli skopírované do schránky!');
      }
    } else {
      navigator.clipboard.writeText(shareText);
      alert('Všetky citáty boli skopírované do schránky!');
    }
  };

  if (favorites.length === 0) {
    return null;
  }

  return (
    <div className="export-section">
      <h3>📤 Export obľúbených citátov</h3>
      <div className="export-buttons">
        <button 
          onClick={exportToJSON}
          className="export-button"
          title="Exportovať ako JSON súbor"
        >
          📋 JSON
        </button>
        
        <button 
          onClick={exportToText}
          className="export-button"
          title="Exportovať ako text súbor"
        >
          📄 Text
        </button>
        
        <button 
          onClick={shareAllFavorites}
          className="export-button"
          title="Zdieľať všetky citáty"
        >
          📤 Zdieľať
        </button>
      </div>
    </div>
  );
};

export default QuoteExport;
